// @flow

import styled from 'styled-components';

export const Link = styled.a`
  color: ${props => props.theme.colors.new_primary[700]};
  text-decoration: underline;
`;
